<!-- 首页 -->
<template>
  <div class="pageHome">
    <transition name="fade-menu">
      <Loading v-if="isLoading" :count='count' />
    </transition>
    <OperationGuide v-if="step > 0 && step < 3 && isNewcomer !== 'false' " :step="step" @changeStep='handleChangeGuideStep' />
    <transition name="fade-menu">
      <MenuList v-if="showMenuLayer" @switchMenu='handleSwitchMenu' />
    </transition>
    <div class="bg_layout">
      <div class="bg_top">
        <img src="static/images/layout_bg_top.png" alt="">
      </div>
      <div class="bg_bottom">
        <img src="static/images/layout_bg_bottom.png" alt="">
      </div>
      <div class="bg_bottom"></div>
    </div>
    <div id="container"></div>
    <transition name='slide-top'>
      <div v-if="showInfo" class="info info_top">
        <div class="home_logo"><img src="static/images/loading_logo.png" alt=""></div>
        <div class="slogan">创新智造永续未来</div>
        <div class="slogan_desc">Innovation at heart for sustainable living</div>
      </div>
    </transition>
    <transition name='slide-bottom'>
      <div v-if="showInfo" class="info info_bottom">
        <div class="home_button"><img @click="handleSwitchMenu" src="static/images/home_button.png" alt=""></div>
        <div class="text">上海国家会展中心6.1馆</div>
        <div class="text">消费品展区 A3-04</div>
      </div>
    </transition>
    <transition name='slide-top'>
      <div v-if="showButtonGroup" class="button-group">
        <div class="back" @click="handleReset"><img src="static/images/img_back.png" alt=""></div>
        <div class="next" @click="handleNext"><img src="static/images/img_next.png" alt=""></div>
      </div>
    </transition>
    <div v-if="showSwipe" class="swipe-modal">
      <SwipeContainer :dataList='currentDataList' @hideSwipe='handleShowSwipe' />
    </div>
    <div class="adhesiveList" ref='adhesiveLayer' :style="{ visibility: adhesivePos.visibility, zIndex: adhesivePos.zIndex, top: adhesivePos.y + 'px', left: adhesivePos.x + 'px'}">
      <div v-for="(item, index) in dataAdhesiveList" @click="handleUpdateSwipe(item.name)" :key="index">{{ item.title }}</div>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading/index.vue'
import * as THREE from 'three'
import OperationGuide from '../../components/OperationGuide/index.vue'
import MenuList from '../../components/MenuList/index.vue'
import SwipeContainer from '@/components/SwipeContainer/index.vue'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import TWEEN from '@tweenjs/tween.js'
import { points, canmeraAreaPox, dataAdhesiveList, dataSwipeProduct } from './data.js'

// const INITIAL_CAMERA_POSITION = { x: 0, y: 10, z: 40 }

export default {
  name: 'Home',
  components: {
    Loading,
    OperationGuide,
    MenuList,
    SwipeContainer
  },
  data () {
    return {
      isLoading: true,
      count: 0,
      mesh: null,
      showInfo: true,
      showButtonGroup: false,
      step: 1,
      isNewcomer: window.localStorage.getItem('newcomer'),
      showMenuLayer: false,
      currentDataList: [],
      showSwipe: false,
      adhesivePos: { zIndex: '-1', x: 0, y: 0, display: 'none', visibility: 'hidden' },
      dataAdhesiveList: []
    }
  },
  computed: {},

  created () {
    console.log('---------created----------')
  },

  mounted () {
    console.log('---------mounted----------')
    this.scene = null
    this.camera = null
    this.renderer = null
    this.orbitControls = null
    this.anme = ''
    this.fov = 45
    this.near = 0.1
    this.far = 500
    this.areaAnchors = []
    this.childAnchors = []
    this.currentAreaName = ''
    this.isLock = false
    this.currentIndex = null

    // html
    this.dataAdhesiveList = dataAdhesiveList

    this.init()
    this.handleLoadModel()
    this.handleAnimate()
    // window.addEventListener('wheel', this.handleUpdateCamera, false)
    // this.orbitControls.addEventListener('change', () => {
    //   console.log(this.camera)
    //   console.log(this.camera.position)
    // })
    // 监听点击事件
    document.body.addEventListener('click', this.handleClickAreaAnchor, false)
  },
  // beforeDestroy () {
  //   this.scene = null
  //   this.camera = null
  //   this.renderer = null
  //   this.orbitControls = null
  //   window.removeEventListener('wheel', this.handleUpdateCamera, false)
  // },
  destroyed () {
    console.log('--------------destroyed-------------')
    // 销毁清除
    // this.scene = null
    // this.camera = null
    // this.renderer = null
    // this.orbitControls = null
    this.areaAnchors = []
    this.childAnchors = []
    this.currentAreaName = ''
    this.areaAnchors = []
    this.orbitControls.removeEventListener('change')
    document.body.removeEventListener('click', this.handleClickAreaAnchor, false)
  },
  methods: {
    /**
     * @description 程序开始
     */
    init () {
      this.initScene()
      this.initCamera()
      this.initLight()
      // this.initAxes()
      this.initRender()
      this.initControl()
    },
    /**
     * @description 初始化场景
     */
    initScene () {
      this.scene = new THREE.Scene()
      const size = 10
      const divisions = 10
      const gridHelper = new THREE.GridHelper(size, divisions)
      this.scene.add(gridHelper)
      // this.scene.background = new THREE.Color('#fefefe')
    },
    /**
     * @description 初始化相机
     */
    initCamera () {
      const container = document.getElementById('container')
      this.camera = new THREE.PerspectiveCamera(this.fov, container.clientWidth / container.clientHeight, this.near, this.far)
      this.camera.position.set(0, 10, 40)
      this.camera.lookAt({ x: 0, y: 0, z: 0 })
    },
    /**
     * @description 初始化辅助坐标系
     */
    initAxes () {
      const axesHelper = new THREE.AxesHelper(200)
      this.scene.add(axesHelper)
    },
    /**
     * @description 初始化灯光
     */
    initLight () {
      const ambient = new THREE.AmbientLight(0xfefefe, 1)
      this.scene.add(ambient)

      const point = new THREE.PointLight(0xffffff, 1)
      point.position.set(10, 300, 0)
      // this.scene.add(point)

      const spotLight = new THREE.SpotLight(0xffff00, 1)
      spotLight.castShadow = true
      spotLight.position.set(100, 100, 0)
      // this.scene.add(spotLight)

      const light = new THREE.DirectionalLight(0xcccccc, 1, 100)
      light.shadow.mapSize.width = 512 // default
      light.shadow.mapSize.height = 512 // default
      light.shadow.camera.near = 0.5 // default
      light.shadow.camera.far = 500 // default

      // 这两个值决定使用多少像素生成阴影 默认512
      // light.shadow.mapSize.height = 1024
      // light.shadow.mapSize.width = 1024
      light.castShadow = true
      // light.position.set(100, 400, 10)
      this.scene.add(light)

      const helper = new THREE.CameraHelper(light.shadow.camera)
      this.scene.add(helper)
    },
    /**
     * @description 初始化渲染器
     */
    initRender () {
      const container = document.getElementById('container')
      this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true })
      this.renderer.setSize(container.clientWidth, container.clientHeight)
      this.renderer.setPixelRatio(window.devicePixelRatio || 1)
      this.renderer.shadowMap.enabled = true
      this.renderer.shadowMap.type = THREE.PCFSoftShadowMap
      container.appendChild(this.renderer.domElement)
    },
    /**
     * @description 初始化控制器
     */
    initControl () {
      this.orbitControls = new OrbitControls(this.camera, this.renderer.domElement)
      this.orbitControls.target.set(0, 0, 0)
      // 惯性
      this.orbitControls.enableDamping = true
      // 动态阻尼系数
      this.orbitControls.dampingFactor = 0.25
      // 缩放
      this.orbitControls.enableZoom = true
      this.orbitControls.maxZoom = 1
      this.orbitControls.minZoom = 1
      // 视角最小距离
      this.orbitControls.minDistance = 1
      // 视角最远距离
      this.orbitControls.maxDistance = 40
      // 右键拖拽
      this.orbitControls.enablePan = true
      // 水平旋转范围
      // this.orbitControls.maxAzimuthAngle = Math.PI / 6
      // this.orbitControls.minAzimuthAngle = -Math.PI / 6
      // 垂直旋转范围
      this.orbitControls.maxPolarAngle = Math.PI / 2
      this.orbitControls.minPolarAngle = -Math.PI / 2

      // const helper = new THREE.CameraHelper(this.orbitControls)
      // this.scene.add(helper)
    },
    /**
     * @description 初始化区域锚点
     */
    initAnchorPoint () {
      const texture = new THREE.TextureLoader().load('static/images/iconHot.png')
      const spriteMaterial = new THREE.SpriteMaterial({
        map: texture,
        transparent: true
      })
      const group = new THREE.Group()
      group.name = 'AnchorGroup'
      console.log('%c 🍺 group: ', 'font-size:20px;background-color: #F5CE50;color:#fff;', group)
      for (let i = 0; i < points.length; i++) {
        const { id, name, position, child } = points[i]
        const sprite = new THREE.Sprite(spriteMaterial)
        sprite.ids = id
        sprite.index = id
        sprite.name = name
        sprite.scale.set(0.5, 0.5, 1)
        sprite.position.set(position.x, position.y, position.z)
        group.add(sprite)
        this.areaAnchors.push(sprite)

        if (child.infos && child.infos.length) {
          const childInfoTexture = new THREE.TextureLoader().load('static/images/img_info.png')
          const childInfoSpriteMaterial = new THREE.SpriteMaterial({
            map: childInfoTexture,
            transparent: true
          })
          const childGroup = new THREE.Group()
          childGroup.name = child.name
          for (let j = 0; j < child.infos.length; j++) {
            const { id, name, position } = child.infos[j]
            const childSprite = new THREE.Sprite(childInfoSpriteMaterial)
            childSprite.ids = id
            childSprite.name = name
            childSprite.scale.set(0.15, 0.15, 1)
            childSprite.position.set(position.x, position.y, position.z)
            childGroup.add(childSprite)
            childGroup.visible = false
            this.childAnchors.push(childSprite)
          }
          this.scene.add(childGroup)
        }
      }
      this.scene.add(group)
    },
    /**
     * @param name 元素name
     * @description 根据name获取元素
     */
    getObjByName (name) {
      return this.scene.getObjectByName(name)
    },
    /**
     * @param id 区域id
     * @description 显示/隐藏 区域锚点
     */
    handleShowDetailAnchor (state) {
      const anchorGroup = this.getObjByName('AnchorGroup')
      anchorGroup.visible = state
    },
    /**
     * @description 点击区域锚点触发事件
     */
    handleClickAreaAnchor (e) {
      e.preventDefault()
      const raycaster = new THREE.Raycaster()
      const pos = this.screenPointToThreeCoords(e.clientX, e.clientY)
      raycaster.setFromCamera(pos, this.camera)
      const anchors = this.currentAreaName ? this.childAnchors : this.areaAnchors
      console.log('%c 🥞 anchors: ', 'font-size:20px;background-color: #3F7CFF;color:#fff;', anchors)
      const intersects = raycaster.intersectObjects(anchors)
      console.log('%c 🥪 intersects: ', 'font-size:20px;background-color: #B03734;color:#fff;', intersects)
      if (intersects.length) {
        const target = intersects[0].object
        this.currentIndex = target.index
        console.log('%c 🍈 target: ', 'font-size:20px;background-color: #42b983;color:#fff;', target)
        if (this.currentAreaName) {
          console.log('target', target)
          if (target.name === 'adhesive_1_1') {
            const { position } = target
            const pos = this.threeCoordsToScreenPoint(position.x, position.y, position.z)
            const w = this.$refs.adhesiveLayer.offsetWidth || 200
            this.adhesivePos = { zIndex: 100, x: pos.x - w - 20, y: pos.y + 20 }
            this.handleShowAdhesiveList()
          } else {
            this.handleUpdateSwipe(target.name)
          }
        } else {
          this.handleSwitchInfo()
          setTimeout(() => {
            this.currentAreaName = target.name
            // console.log('this.camera', this.camera)
            // console.log('this.orbitControls.target', this.orbitControls.target)
            const nextPos = canmeraAreaPox.find((item) => item.id === target.ids)
            this.handleUpdateCamera(this.camera.position, this.orbitControls.target, nextPos.position, target.position, () => {
              this.handleShowDetailAnchor(false)
              this.handleAreaInfo(target.name, true)
              this.handleSwitchBtnGroup()
            })
            // 调节相机视口宽高比
            // this.camera.aspect = nextPos.aspect
            // this.handleAreaInfo(target.name, true)
            // this.handleSwitchBtnGroup()
          }, 800)
        }
      }
    },
    handleUpdateSwipe (name) {
      console.log('%c 🍵 name: ', 'font-size:20px;background-color: #7F2B82;color:#fff;', name)
      const currentData = dataSwipeProduct[name]
      if (currentData) {
        this.currentDataList = currentData
        this.handleShowSwipe()
      }
    },
    /**
     * @param name Object name
     * @description 根据选择的区域，渲染区域内信息
     */
    handleAreaInfo (name, state) {
      const currentAreaInfo = points.find((item) => item.name === name)
      const childGroup = this.getObjByName(currentAreaInfo.child.name)
      if (childGroup) {
        childGroup.visible = state
      }
    },
    /**
     * @param x 点击屏幕x坐标
     * @param y 点击屏幕时的y坐标
     * @description 根据点击的屏幕坐标转换成3d坐标
     */
    screenPointToThreeCoords (x, y) {
      const pos = new THREE.Vector2()

      pos.x = (x / window.innerWidth) * 2 - 1
      pos.y = -(y / window.innerHeight) * 2 + 1

      return pos
    },
    threeCoordsToScreenPoint (x, y, z) {
      const halfWidth = window.innerWidth / 2
      const halfHeight = window.innerHeight / 2
      const vec3 = new THREE.Vector3(x, y, z)
      const pos = vec3.project(this.camera)
      return { x: pos.x * halfWidth + halfWidth, y: -pos.y * halfHeight + halfHeight }
    },
    /**
     * @description 加载3d场景模型
     */
    handleLoadModel () {
      const _this = this
      const loader = new GLTFLoader()
      return new Promise((resolve, reject) => {
        loader.load('static/model/1.gltf', (gltf) => {
          console.log(gltf)
          const root = gltf.scene
          console.log('%c 🎂 root: ', 'font-size:20px;background-color: #FFDD4D;color:#fff;', root)
          root.traverse(child => {
            // console.log('%c 🥕 child: ', 'font-size:20px;background-color: #6EC1C2;color:#fff;', child)
            if (child.isMesh) {
              child.material.metalness = 0.2
              child.material.roughness = 0.2
              child.castShadow = true
              child.receiveShadow = true
            }
            if (child.name === 'floor_1_grass_door') {
              child.material.transparent = true
              child.material.opacity = 0.5
            }
          })
          root.position.set(0, 0, 0)
          const group = new THREE.Group()
          group.add(root)

          const texture = new THREE.TextureLoader().load('static/images/spin_map.png')
          const geometry = new THREE.PlaneGeometry(14, 14)
          const material = new THREE.MeshBasicMaterial({ map: texture, transparent: true, side: THREE.DoubleSide })
          const plane = new THREE.Mesh(geometry, material)
          plane.position.set(0, 0, 0)
          plane.rotateX(-Math.PI / 2)
          group.add(plane)

          const box = new THREE.Box3()
          box.setFromObject(group)
          const wrapper = new THREE.Object3D()
          wrapper.add(group)
          wrapper.position.set(0, 0, 0)
          _this.scene.add(wrapper)
          this.initAnchorPoint()
        }, xhr => {
          console.log('%c 🥧 xhr: ', 'font-size:20px;background-color: #F5CE50;color:#fff;', xhr)
          // console.log((xhr.loaded / xhr.total * 100) + '%')
          const number = xhr.loaded / xhr.total * 100
          this.count = Math.floor(number)
          if (number >= 100) {
            setTimeout(() => {
              this.isLoading = false
            }, 1000)
          }
        }, error => {
          console.log('%c 🍤 error: ', 'font-size:20px;background-color: #FCA650;color:#fff;', error)
        })
      })
    },
    /**
     * @param currentPos 当前相机坐标
     * @param currentTarget 当前控制器坐标
     * @param nextPos 下一次相机坐标
     * @param nextTaget 下一次控制器坐标
     * @param callback 回调函数
     * @description 相机动画
     */
    handleUpdateCamera (currentPos, currentTarget, nextPos, nextTaget, callback) {
      const tween = new TWEEN.Tween({
        x1: currentPos.x,
        y1: currentPos.y,
        z1: currentPos.z,
        x2: currentTarget.x,
        y2: currentTarget.y,
        z2: currentTarget.z
      })
      tween.to({
        x1: nextPos.x,
        y1: nextPos.y,
        z1: nextPos.z,
        x2: nextTaget.x,
        y2: nextTaget.y,
        z2: nextTaget.z
      }, 1000)
      tween.onUpdate((object) => {
        // console.log('%c 🥜 object: ', 'font-size:20px;background-color: #ED9EC7;color:#fff;', object)
        this.camera.position.x = object.x1
        this.camera.position.y = object.y1
        this.camera.position.z = object.z1
        // this.camera.lookAt({ x: object.x2, y: object.y2, z: object.z2 })
        this.orbitControls.target.x = object.x2
        this.orbitControls.target.y = object.y2
        this.orbitControls.target.z = object.z2
        this.orbitControls.update()
      })
      tween.onComplete(() => {
        this.orbitControls.enabled = true
        callback && callback()
      })
      tween.easing(TWEEN.Easing.Cubic.InOut)
      tween.start()
    },
    handleReset (needUpdate = true, callback) {
      const cameraOrigin = { x: 0, y: 10, z: 40 }
      const controlOrigin = { x: 0, y: 0, z: 0 }
      // 相机锁定返回
      if (this.isLock) {
        this.isLock = false
        this.orbitControls.enabled = true
        this.adhesivePos.zIndex = -1
        this.adhesivePos.visibility = 'hidden'
      }
      this.handleAreaInfo(this.currentAreaName, false)
      this.handleUpdateCamera(this.camera.position, this.orbitControls.target, cameraOrigin, controlOrigin, () => {
        if (needUpdate) {
          this.handleShowDetailAnchor(true)
          this.handleSwitchBtnGroup()
          this.handleSwitchInfo()
          this.currentAreaName = ''
        }
        callback && callback()
      })
    },
    handleNext () {
      // 相机锁定下一个场景
      if (this.isLock) {
        this.isLock = false
        this.orbitControls.enabled = true
        this.adhesivePos.zIndex = -1
        this.adhesivePos.visibility = 'hidden'
      }
      console.log('this.currentIndex', this.currentIndex)
      const nextPos = canmeraAreaPox.find((item) => item.id === this.currentIndex)
      this.handleUpdateCamera(this.camera.position, this.orbitControls.target, nextPos.position, nextPos.position)
      this.handleReset(false)
    },
    /**
     * @description 开启场景渲染
     */
    handleAnimate () {
      requestAnimationFrame(this.handleAnimate)
      this.renderer.render(this.scene, this.camera)
      TWEEN.update()
    },
    /**
     * @description 显示/隐藏logo、公司信息
     */
    handleSwitchInfo () {
      this.showInfo = !this.showInfo
    },
    handleSwitchBtnGroup () {
      this.showButtonGroup = !this.showButtonGroup
    },
    /**
     * @description 初次进入，控制指引
     */
    handleChangeGuideStep () {
      this.step += 1
      if (this.step > 2) {
        window.localStorage.setItem('newcomer', false)
      }
    },
    /**
     * @description 控制菜单
     */
    handleSwitchMenu () {
      this.showMenuLayer = !this.showMenuLayer
    },
    handleShowSwipe () {
      this.showSwipe = !this.showSwipe
    },
    handleShowAdhesiveList () {
      this.isLock = !this.isLock
      this.orbitControls.enabled = !this.orbitControls.enabled
      if (this.isLock) {
        this.adhesivePos.zIndex = 99
        this.adhesivePos.visibility = 'visible'
      } else {
        this.adhesivePos.zIndex = -1
        this.adhesivePos.visibility = 'hidden'
      }
    }
  }
}

</script>

<style>
.van-swipe__track {
  height: 1134px;
}
.van-swipe__indicator {
  width: 22px;
  height: 22px;
  background-color: #fff;
}
.van-swipe__indicator--active {
  background-color: #e10010 !important;
}
</style>
<style lang='less' scoped>
  .pageHome {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
  }
  .bg_layout {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: -1;
  }
  .bg_top {
    /* width: 748px; */
    img{
      width: 748px;
    }
  }
  .bg_bottom {
    img {
      width: 737px;
    }
  }
  #container {
    width: 100%;
    height: 100vh;
  }
  .info_top {
    top: 100px;
    right: 30px;
    position: absolute;
    text-align: right;
  }
  .home_logo {
    display: flex;
    justify-content: flex-end;

    img {
      width: 128px;
      height: 68px;
      display: block;
    }
  }
  .slogan {
    font-size: 52px;
    font-weight: bold;
    color: #e10010;
    margin-top: 10px;
  }
  .slogan_desc {
    font-size: 26px;
    font-weight: lighter;
    color: #e10010;
  }
  .info_bottom {
    width: 100%;
    bottom: 30px;
    position: absolute;
  }
  .home_button {
    display: flex;
    justify-content: center;

    img {
      width: 75px;
      height: 75px;
      display: block;
    }
  }

  .text {
    font-size: 24px;
    color: #2a2d2f;
    padding-left: 30px;
  }
  .btn {
    width: 200px;
    height: 60px;
    background-color: #ccc;
    border-radius: 15px;
    font-size: 24px;
    position: absolute;
    top: 100px;
    left: 30px;
  }

  .button-group {
    width: 100%;
    padding: 0 30px;
    position: absolute;
    top: 50px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;

    .back {
      width: 125px;
      height: 46px;
      img {
        width: 100%;
        display: block;
      }
    }
    .next {
      width: 167px;
      height: 46px;
      img {
        width: 100%;
        display: block;
      }
    }
  }

  .swipe-modal {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .my-swipe {
      width: 650px;
      height: 1180px;
    }

    .my-swipe .van-swipe-item {
      color: #fff;
      font-size: 20px;
      line-height: 150px;
      text-align: center;
      background-color: #39a9ed;
    }
  }

  .adhesiveList {
    position: absolute;
    z-index: -1;
    visibility: hidden;
    background-color: #e10010;

    div {
      width: 400px;
      height: 80px;
      padding: 0 30px;
      display: flex;
      align-items: center;
      line-height: 80px;
      color: #fff;
      font-size: 24px;
      position: relative;
      box-sizing: border-box;

      &::before {
        content: '';
        display: inline-block;
        width: 40px;
        height: 40px;
        margin-right: 20px;
        background-repeat: no-repeat;
        background-size: contain;
      }
      &::after {
        content: '';
        display: inline-block;
        width: 90%;
        height: 2px;
        position: absolute;
        bottom: 0;
        left: 5%;
        background-color: #c50311;
      }
      &:nth-child(1)::before {
        background-image: url('/static/images/icon_electrical.png');
      }
      &:nth-child(2)::before {
        background-image: url('/static/images/icon_car.png');
      }
      &:nth-child(3)::before {
        background-image: url('/static/images/icon_electronic.png');
      }
      &:nth-child(4)::before {
        background-image: url('/static/images/icon_medical.png');
      }
      &:nth-child(5)::before {
        background-image: url('/static/images/icon_furniture.png');
      }
      &:nth-child(6)::before {
        background-image: url('/static/images/icon_textile.png');
      }
      &:nth-child(7)::before {
        background-image: url('/static/images/icon_industry.png');
      }
      &:nth-child(7)::after {
        display: none;
      }
    }
  }

  .slide-top-enter-active, .slide-top-leave-active, .slide-bottom-enter-active, .slide-bottom-leave-active {
    transition: all 0.5s ease;
  }
  .slide-top-enter, .slide-top-leave-to {
    transform: translateY(-80px);
    opacity: 0;
  }
  .slide-bottom-enter, .slide-bottom-leave-to {
    transform: translateY(80px);
    opacity: 0;
  }

  .fade-menu-enter-active, .fade-menu-leave-active {
    transition: all 1s ease;
  }
  .fade-menu-enter, .fade-menu-leave-to {
    opacity: 0;
  }
</style>
